import React, {useState} from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  ListGroup,
} from "react-bootstrap";
import {
  FaHeadset,
  FaPaperPlane,
  FaEnvelope,
  FaPhone,
  FaQuestionCircle,
} from "react-icons/fa";
import {Link} from "react-router-dom";
import userInfo from "../data/user.json"; // Importamos los datos del usuario

const Support = () => {
  const [ticket, setTicket] = useState({
    name: userInfo.name, // Pre-llenado con datos del usuario
    email: userInfo.email, // Pre-llenado con datos del usuario
    subject: "",
    message: "",
    priority: "normal",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const {name, value} = e.target;
    setTicket({...ticket, [name]: value});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí iría la lógica para enviar el ticket a una API de soporte
    console.log("Enviando ticket:", ticket);
    setIsSubmitted(true);
    // Resetear el formulario después de un tiempo
    setTimeout(() => {
      setIsSubmitted(false);
      setTicket({
        ...ticket,
        subject: "",
        message: "",
        priority: "normal",
      });
    }, 5000);
  };

  return (
    <Container fluid className="p-4 bg-light">
      <Row>
        {/* Columna del Formulario de Soporte */}
        <Col lg={8}>
          <Card className="shadow-sm rounded-4 border-0">
            <Card.Header className="bg-white p-3 border-bottom-0">
              <h5 className="mb-0 fw-bold">
                <FaHeadset className="me-2 text-success" />
                Contactar a Soporte Técnico
              </h5>
              <p className="text-muted mb-0 small">
                Completa el formulario y te responderemos a la brevedad.
              </p>
            </Card.Header>
            <Card.Body className="p-4">
              {isSubmitted ? (
                <Alert variant="success">
                  <Alert.Heading>¡Ticket enviado con éxito!</Alert.Heading>
                  <p>
                    Hemos recibido tu solicitud. Un miembro de nuestro equipo se
                    pondrá en contacto contigo pronto.
                  </p>
                </Alert>
              ) : (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Tu Nombre</Form.Label>
                        <Form.Control
                          type="text"
                          value={ticket.name}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Tu Correo</Form.Label>
                        <Form.Control
                          type="email"
                          value={ticket.email}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Group className="mb-3">
                    <Form.Label>Asunto</Form.Label>
                    <Form.Control
                      type="text"
                      name="subject"
                      value={ticket.subject}
                      onChange={handleChange}
                      placeholder="Ej: Problema al crear campaña"
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Describe tu problema</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="message"
                      value={ticket.message}
                      onChange={handleChange}
                      rows={5}
                      placeholder="Por favor, detalla tu consulta aquí..."
                      required
                    />
                  </Form.Group>
                  <Button variant="success" type="submit">
                    <FaPaperPlane className="me-2" />
                    Enviar Ticket
                  </Button>
                </Form>
              )}
            </Card.Body>
          </Card>
        </Col>

        {/* Columna de Información Adicional */}
        <Col lg={4}>
          <Card className="shadow-sm rounded-4 border-0">
            <Card.Header className="bg-white p-3 border-bottom-0">
              <h5 className="mb-0 fw-bold">Otras formas de ayuda</h5>
            </Card.Header>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <FaEnvelope className="me-2 text-success" />
                <strong>Email:</strong> soporte@portercom.cl
              </ListGroup.Item>
              <ListGroup.Item>
                <FaPhone className="me-2 text-success" />
                <strong>Teléfono:</strong> +56 2 1234 5678
              </ListGroup.Item>
              <ListGroup.Item action as={Link} to="/help">
                <FaQuestionCircle className="me-2 text-success" />
                Visita nuestro <strong>Centro de Ayuda</strong>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Support;
